module.exports = __webpack_public_path__ + "732389ded34cb9c52dd88271f1345af9.ttf";


//////////////////
// WEBPACK FOOTER
// ./theme/fonts/element-icons.ttf
// module id = 223
// module chunks = 1